import React from 'react';

import './css/Faq.css'

import { Page } from './Page';

import { CONTACT_EMAIL, TALK_TO_US_URL, TALK_TO_US_LABEL } from './contact'
import { FAQ_GROUPS, FaqEntry, FaqGroup } from './faqEntries'


function FaqItem( { entry }: { entry: FaqEntry } ): React.JSX.Element {

	// Native disclosure: keyboard and screen-reader behaviour for free, and
	// the browser's find-in-page opens a closed answer on a match.
	return (
		<details className="Faq-Item" >
			<summary className="Faq-Question fs-18" >{ entry.question }</summary>
			<div className="Faq-Answer Page-Text fs-18" >{ entry.answer }</div>
		</details>
	)
}

export function Faq(): React.JSX.Element {

	return (
		<Page title="Underlayer — FAQ" className="Faq" >

			<div className="Pane-Light Page-Section Page-Section-First Faq-Section" >
				<div className="Container" >
					<div className="Page-Label" >FAQ</div>
					<div className="Title text-shadow-2" data-fade >Frequently asked questions.</div>
					<div className="Faq-Intro Page-Text fs-18" data-fade data-fade-delay="0.15" >
						What Underlayer does, what the watermark survives, and what it takes to run it.
					</div>

					{ FAQ_GROUPS.map( ( group: FaqGroup, index: number ): React.JSX.Element => (
						<div className="Faq-Group" key={ group.title } data-fade data-fade-delay={ ( 0.1 + index * 0.05 ).toFixed( 2 ) } >
							<div className="Faq-Group-Title" >{ group.title }</div>
							<div className="Faq-Group-Items" >
								{ group.entries.map( ( entry: FaqEntry ): React.JSX.Element => (
									<FaqItem entry={ entry } key={ entry.question } />
								) ) }
							</div>
						</div>
					) ) }

					<div className="Faq-More" data-fade >
						<div className="Faq-More-Title" >Still have a question?</div>
						<div className="Page-Text fs-18" >
							Write to <a href={ `mailto:${ CONTACT_EMAIL }` } >{ CONTACT_EMAIL }</a> or book twenty minutes with the founders.
						</div>
						<a href={ TALK_TO_US_URL } target="_blank" rel="noopener noreferrer" className="Faq-Cta" >{ TALK_TO_US_LABEL }</a>
					</div>
				</div>
			</div>

		</Page>
	)
}
